export const features = [
  {
    icon: 'ri-smartphone-line',
    title: '智能创作工具',
    description: '内置AI智能剪辑、自动配乐、滤镜调色等强大工具，即使是新手也能轻松创作出专业水准的短视频内容。',
  },
  {
    icon: 'ri-funds-line',
    title: '多元变现体系',
    description: '流量分成、品牌合作、直播打赏、电商带货四大变现路径，让每一位优质创作者的才华都能转化为实际收益。',
  },
  {
    icon: 'ri-user-heart-line',
    title: '创作者成长计划',
    description: '分级成长体系搭配专属流量扶持，从新手到头部创作者，每一步都有平台的陪伴与助力。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '全方位安全保障',
    description: '内容版权保护、账号安全防护、青少年模式等多重安全机制，为用户和创作者营造安心可信赖的平台环境。',
  },
  {
    icon: 'ri-ai-generate',
    title: 'AI创作助手',
    description: 'AI智能生成文案、设计封面、优化标题，让创作效率提升数倍，把时间留给更有价值的创意思考。',
  },
  {
    icon: 'ri-global-line',
    title: '海量内容生态',
    description: '覆盖生活、知识、娱乐、美食等数十个内容领域，满足不同用户的多元兴趣需求，发现属于你的精彩世界。',
  },
];